import React from "react";
import {
  GreenCardBag,
  SearchIcon,
  ShoppingBag,
  OrdibeheshtLogo,
  SortIcon,
  ArrowSquareLeft,
  WhatsApp,
  Spotify,
  BrownTwitterIcon,
  GreenTwitterIcon,
  Viber,
  Telegram,
  GreenLinkdin,
  Setting,
  BrownInstagram,
  GreenInstagram,
  HeartIcon,
  GreenYoutube,
  ShareIcon,
  BrownCircleProfile,
  OrderListIcon,
  CloseSquare,
  BrownFacebook,
  BrownSwitchIcon,
  Location,
  MedalStar,
  TruckFast,
  CardsIcon,
  BrownClock,
  BrownCall,
  TwentyFourSupport,
  ArrowUp,
  AddBtn,
  FullStarIcon,
  HalfStarIcon,
} from "./index.js";

const IconViewer = ({ icon }) => {
  if (icon === undefined) {
    console.log(
      "%cbackend Must give me Icon To show",
      "color: #f709bb; font-family: sans-serif; font-size:20px;"
    );
    return <></>;
  }
  return (
    <>
      {icon === "GreenCardBag" && <GreenCardBag />}
      {icon === "AddBtn" && <AddBtn />}
      {icon === "SearchIcon" && <SearchIcon />}
      {icon === "ShoppingBag" && <ShoppingBag />}
      {icon === "OrdibeheshtLogo" && <OrdibeheshtLogo />}
      {icon === "SortIcon" && <SortIcon />}
      {icon === "ArrowSquareLeft" && <ArrowSquareLeft />}
      {icon === "WhatsApp" && <WhatsApp />}
      {icon === "Spotify" && <Spotify />}
      {icon === "BrownTwitterIcon" && <BrownTwitterIcon />}
      {icon === "GreenTwitterIcon" && <GreenTwitterIcon />}
      {icon === "Viber" && <Viber />}
      {icon === "Telegram" && <Telegram />}
      {icon === "GreenLinkdin" && <GreenLinkdin />}
      {icon === "Setting" && <Setting />}
      {icon === "BrownInstagram" && <BrownInstagram />}
      {icon === "GreenInstagram" && <GreenInstagram />}
      {icon === "HeartIcon" && <HeartIcon />}
      {icon === "GreenYoutube" && <GreenYoutube />}
      {icon === "ShareIcon" && <ShareIcon />}
      {icon === "BrownCircleProfile" && <BrownCircleProfile />}
      {icon === "OrderListIcon" && <OrderListIcon />}
      {icon === "CloseSquare" && <CloseSquare />}
      {icon === "BrownFacebook" && <BrownFacebook />}
      {icon === "BrownSwitchIcon" && <BrownSwitchIcon />}
      {icon === "Location" && <Location />}
      {icon === "MedalStar" && <MedalStar />}
      {icon === "TruckFast" && <TruckFast />}
      {icon === "CardsIcon" && <CardsIcon />}
      {icon === "BrownClock" && <BrownClock />}
      {icon === "BrownCall" && <BrownCall />}
      {icon === "TwentyFourSupport" && <TwentyFourSupport />}
      {icon === "ArrowUp" && <ArrowUp />}
      {icon === "FullStarIcon" && <FullStarIcon />}
      {icon === "HalfStarIcon" && <HalfStarIcon />}
    </>
  );
};

export default IconViewer;
